import axios from "axios"

function request(method, path, data, params) {
  return axios({ method, url: "/api/contract-workspace" + path, data, params, headers: { Authorization: localStorage.getItem("token") } }).then((response) => response.data)
}

export function errorMessage(error) {
  if (error.response && error.response.data && error.response.data.message) return error.response.data.message
  if (error.response && [401, 403].includes(error.response.status)) return "Deine Sitzung oder Berechtigung ist nicht mehr gültig. Bitte die App neu öffnen."
  return "Die Verbindung zur Vertragsverwaltung ist fehlgeschlagen. Bitte erneut versuchen."
}

export default {
  context: () => request("get", "/context"),
  catalog: (studioId) => request("get", "/catalog", null, { studioId }),
  previewImport: (studioId) => request("post", "/catalog/import-preview", { studioId }),
  applyImport: (id, data) => request("post", "/catalog/imports/" + encodeURIComponent(id) + "/apply", data),
  quote: (data) => request("post", "/quotes", data),
  prepare: (data) => request("post", "/prepare", data),
  agreements: (studioId, offset = 0) => request("get", "/agreements", null, { studioId: studioId || undefined, offset }),
  agreement: (id) => request("get", "/agreements/" + encodeURIComponent(id)),
  create: (data) => request("post", "/agreements", data),
  update: (id, data) => request("put", "/agreements/" + encodeURIComponent(id), data),
  note: (id, data) => request("post", "/agreements/" + encodeURIComponent(id) + "/notes", data),
}
